import React, { useState, useEffect } from 'react';
import BaseForm from '../../app/components/BaseForm';
import Input from '../../app/components/Input';
import Select from '../../app/components/Select';

const FormNovaSequencia = ({ isOpen, onClose, onSubmit, addCardToKanban }) => {
  const initialState = {
    responsavel: '',
    nomeCliente: '',
    email: '',
    telefone: '',
    cnpj: '',
    razaoSocial: '',
    nomeFantasia: '',
    regime: '',
    tipoEntrada: '',
    honorarioAbertura: '',
    honorarioMensal: '',
    segmento: '',
    qtdFuncionarios: '',
    possuiMovimento: '',
    ramoAtuacao: '',
    responsavelVenda: '',
    canalVendas: '',
    indicadoPor: '',
    unidade: '',
    competenciaInicial: '',
    dataContrato: '',
    dataVencimento: '',
    observacoes: '',
    endereco: '',
    numero: '',
    bairro: '',
    complemento: '',
    cidade: '',
    estado: '',
    uf: '',
    cep: '',
    atividadeEconomica: '',
    capitalSocial: '',
    situacaoCadastral: '',
    inscricaoEstadual: '',
  };

  const [form, setForm] = useState(initialState);

  useEffect(() => {
    if (!isOpen) {
      setForm(initialState);
    }
  }, [isOpen]);

  const isValid =
    form.responsavel &&
    form.nomeCliente &&
    form.regime &&
    form.honorarioMensal &&
    form.segmento &&
    form.qtdFuncionarios &&
    form.possuiMovimento;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleSubmit = () => {
    if (isValid) {
      const newCard = {
        id: `${form.nomeCliente?.substring(0, 5)}-${Date.now()}`,
        titulo: form.nomeFantasia || "NOVA SEQUÊNCIA",
        client: form.nomeCliente,
        razaoSocial: form.razaoSocial || form.nomeCliente,
        nomeFantasia: form.nomeFantasia,
        email: form.email,
        telefone: form.telefone,
        cnpj: form.cnpj,
        value: form.honorarioMensal,
        service: form.regime,
        dataFechamento: form.dataVencimento,
        temperatura: '',
        observacoes: form.observacoes,
        anexos: [],
        tags: [],
        segmento: form.segmento,
        competenciaInicial: form.competenciaInicial,
        vencimento: form.dataVencimento,
        qtdFuncionarios: form.qtdFuncionarios,
        ramoAtuacao: form.ramoAtuacao,
        possuiMovimento: form.possuiMovimento,
        responsavel: form.responsavel,
        unidade: form.unidade,
        reminders: [
          { id: `r-${Date.now()}-1`, days: 30, type: "info" }
        ],
        columnId: "negotiation",
        hasEmail: !!form.email,
        hasFile: false,
        fileCount: undefined,
        hasObservacoes: !!form.observacoes,
        lastUpdate: "agora",
        messageCount: 0
      };

      if (addCardToKanban) {
        addCardToKanban(newCard, "negotiation");
      }

      onSubmit(form);
      onClose();
    } else {
      alert("Por favor, preencha todos os campos obrigatórios.");
    }
  };

  const responsaveis = [
    { value: 'Adriellen Neves', label: 'Adriellen Neves' },
    { value: 'ALISON DOS SANTOS SANTANA', label: 'ALISON DOS SANTOS SANTANA' },
    { value: 'Alison Santana', label: 'Alison Santana' },
    { value: 'Allan', label: 'Allan' },
    { value: 'Ana Célia', label: 'Ana Célia' },
    { value: 'André Anjos', label: 'André Anjos' },
    { value: 'Barbara Lima', label: 'Barbara Lima' },
    { value: 'Bruna Rodrigues', label: 'Bruna Rodrigues' },
    { value: 'Celianny Pessoa', label: 'Celianny Pessoa' },
    { value: 'Danielle Rayol', label: 'Danielle Rayol' },
    { value: 'Davi Fonseca Gomes', label: 'Davi Fonseca Gomes' },
    { value: 'Eduardo Oliveira da Silva', label: 'Eduardo Oliveira da Silva' },
    { value: 'Elivelton', label: 'Elivelton' },
    { value: 'Emanuel Araujo', label: 'Emanuel Araujo' },
    { value: 'Emyliano Silva Araújo', label: 'Emyliano Silva Araújo' },
    { value: 'Estagiário DP', label: 'Estagiário DP' },
    { value: 'Esther', label: 'Esther' },
    { value: 'Fabricio Pereira', label: 'Fabricio Pereira' },
    { value: 'Felipe Mesquita', label: 'Felipe Mesquita' },
    { value: 'Jaciane Oliveira', label: 'Jaciane Oliveira' },
    { value: 'JARIVAN ALENCAR SANTOS', label: 'JARIVAN ALENCAR SANTOS' },
    { value: 'Jhenifer', label: 'Jhenifer' },
    { value: 'João Victor', label: 'João Victor' },
    { value: 'Joseph Lima', label: 'Joseph Lima' },
    { value: 'José Victor', label: 'José Victor' },
    { value: 'Josiane Ramos Pacheco', label: 'Josiane Ramos Pacheco' },
    { value: 'Karol Paixão', label: 'Karol Paixão' },
    { value: 'Kassiany Pires', label: 'Kassiany Pires' },
    { value: 'Lany Dino', label: 'Lany Dino' },
    { value: 'Laura Rosa', label: 'Laura Rosa' },
    { value: 'Luís Felipe Conceição', label: 'Luís Felipe Conceição' },
    { value: 'Mariana Lopes', label: 'Mariana Lopes' },
    { value: 'Maria Victoria', label: 'Maria Victoria' },
    { value: 'Matheus Faiola', label: 'Matheus Faiola' },
    { value: 'Mikael Ferreira', label: 'Mikael Ferreira' },
    { value: 'Milena', label: 'Milena' },
    { value: 'Moises', label: 'Moises' },
    { value: 'Natallia Marissa', label: 'Natallia Marissa' },
    { value: 'Nataly Bruna Silva dos Santos', label: 'Nataly Bruna Silva dos Santos' },
    { value: 'Nathalia Leal', label: 'Nathalia Leal' },
    { value: 'Nilce Miranda', label: 'Nilce Miranda' },
    { value: 'Patricia Xavier Albuquerque', label: 'Patricia Xavier Albuquerque' },
    { value: 'Paulo', label: 'Paulo' },
    { value: 'Pedro Henrique', label: 'Pedro Henrique' },
    { value: 'Polyane Ferreira', label: 'Polyane Ferreira' },
    { value: 'Rafael Rocha Miranda Pontes dos Santos', label: 'Rafael Rocha Miranda Pontes dos Santos' },
    { value: 'Raquel Campos', label: 'Raquel Campos' },
    { value: 'Rayana', label: 'Rayana' },
    { value: 'Regyna Abreu', label: 'Regyna Abreu' },
    { value: 'Sâmara Aquino', label: 'Sâmara Aquino' },
    { value: 'Samara Rocha da Silva Reis', label: 'Samara Rocha da Silva Reis' },
    { value: 'Samuel Mota', label: 'Samuel Mota' },
    { value: 'Sara Oliveira', label: 'Sara Oliveira' },
    { value: 'Thaíssa de Almeida Seguins Aguiar', label: 'Thaíssa de Almeida Seguins Aguiar' },
    { value: 'Thiago Raulino', label: 'Thiago Raulino' },
    { value: 'Wellington Martins', label: 'Wellington Martins' },
  ];

  const regimes = [
    { value: 'SIMPLES NACIONAL', label: 'SIMPLES NACIONAL' },
    { value: 'LUCRO PRESUMIDO', label: 'LUCRO PRESUMIDO' },
    { value: 'LUCRO REAL', label: 'LUCRO REAL' },
    { value: 'PESSOA FÍSICA', label: 'PESSOA FÍSICA' },
    { value: 'MEI', label: 'MEI' },
    { value: 'IMUNES/ISENTAS', label: 'IMUNES/ISENTAS' },
  ];

  const tiposEntrada = [
    { value: 'Abertura', label: 'Abertura' },
    { value: 'Transferência', label: 'Transferência' },
  ];

  const segmentos = [
    { value: 'Comércio', label: 'Comércio' },
    { value: 'Serviço', label: 'Serviço' },
    { value: 'Comércio e Serviço', label: 'Comércio e Serviço' },
    { value: 'MEI', label: 'MEI' },
    { value: 'E-Social', label: 'E-Social' },
  ];

  const possuiMovimento = [
    { value: 'Sim', label: 'Sim' },
    { value: 'Não', label: 'Não' },
  ];

  const ramosAtuacao = [
    { value: 'Administradora de Condomínios', label: 'Administradora de Condomínios' },
    { value: 'Advocacia', label: 'Advocacia' },
    { value: 'Arquitetura', label: 'Arquitetura' },
    { value: 'Associação', label: 'Associação' },
    { value: 'Atividade Física', label: 'Atividade Física' },
    { value: 'Bar e Restaurante', label: 'Bar e Restaurante' },
    { value: 'Clínica Médica', label: 'Clínica Médica' },
    { value: 'Condomínio', label: 'Condomínio' },
    { value: 'Consultoria e Treinamento', label: 'Consultoria e Treinamento' },
    { value: 'Contabilidade', label: 'Contabilidade' },
    { value: 'Distribuidora', label: 'Distribuidora' },
    { value: 'E-comercee', label: 'E-comercee' },
    { value: 'Educação', label: 'Educação' },
    { value: 'Energia Solar', label: 'Energia Solar' },
    { value: 'Engenharia', label: 'Engenharia' },
    { value: 'E-social', label: 'E-social' },
    { value: 'Estética', label: 'Estética' },
    { value: 'Eventos', label: 'Eventos' },
    { value: 'Farmácia', label: 'Farmácia' },
    { value: 'Fisioterapia', label: 'Fisioterapia' },
    { value: 'Gráfica', label: 'Gráfica' },
    { value: 'Holding', label: 'Holding' },
    { value: 'Hotel', label: 'Hotel' },
    { value: 'Imobiliária', label: 'Imobiliária' },
    { value: 'Inovação', label: 'Inovação' },
    { value: 'Lava Jato', label: 'Lava Jato' },
    { value: 'Lavanderia', label: 'Lavanderia' },
    { value: 'Loja de Varejo', label: 'Loja de Varejo' },
    { value: 'Manutenção', label: 'Manutenção' },
    { value: 'Marcenaria', label: 'Marcenaria' },
    { value: 'Marketing Digital', label: 'Marketing Digital' },
    { value: 'Material de Construção', label: 'Material de Construção' },
    { value: 'Material Hospitalar', label: 'Material Hospitalar' },
    { value: 'Móveis', label: 'Móveis' },
    { value: 'Nutrição', label: 'Nutrição' },
    { value: 'Odontologia', label: 'Odontologia' },
    { value: 'Ótica', label: 'Ótica' },
    { value: 'Padaria', label: 'Padaria' },
    { value: 'Pet Shop', label: 'Pet Shop' },
    { value: 'Posto de Combustível', label: 'Posto de Combustível' },
    { value: 'Pjtinha', label: 'Pjtinha' },
    { value: 'Produção de filmes', label: 'Produção de filmes' },
    { value: 'Rádio', label: 'Rádio' },
    { value: 'Representante', label: 'Representante' },
    { value: 'Rodoviária', label: 'Rodoviária' },
    { value: 'Rural', label: 'Rural' },
    { value: 'Salão', label: 'Salão' },
    { value: 'Serviço de apoio administrativo', label: 'Serviço de apoio administrativo' },
    { value: 'Segurança', label: 'Segurança' },
    { value: 'Tecnologia', label: 'Tecnologia' },
    { value: 'Terapia Ocupacional', label: 'Terapia Ocupacional' },
    { value: 'Transportadora', label: 'Transportadora' },
    { value: 'Turismo', label: 'Turismo' },
    { value: 'Industria', label: 'Industria' },
  ];

  const canaisVenda = [
    { value: 'Indicação Cliente', label: 'Indicação Cliente' },
    { value: 'Expansão', label: 'Expansão' },
    { value: 'Equipe', label: 'Equipe' },
    { value: 'Vendas direta', label: 'Vendas direta' },
    { value: 'Redes Sociais', label: 'Redes Sociais' },
    { value: 'Eventos', label: 'Eventos' },
    { value: 'Afiliado', label: 'Afiliado' },
    { value: 'Networking', label: 'Networking' },
  ];

  const unidades = [
    { value: 'SÃO LUÍS', label: 'SÃO LUÍS' },
    { value: 'IMPERATRIZ', label: 'IMPERATRIZ' },
    { value: 'TERESINA', label: 'TERESINA' },
  ];

  return (
    <BaseForm
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={handleSubmit}
      title="Criar Nova Sequência"
      className='max-w-4xl'
    >
      <div className="grid grid-cols-1 gap-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Select
            id="responsavel"
            name="responsavel"
            label="Responsável *"
            value={form.responsavel}
            onChange={handleChange}
            options={responsaveis}
            required
          />

          <Input
            id="nomeCliente"
            name="nomeCliente"
            label="Nome do Cliente *"
            value={form.nomeCliente}
            onChange={handleChange}
            required
            hint="Obrigatório para gerar Proposta."
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            id="email"
            name="email"
            label="Email"
            value={form.email}
            onChange={handleChange}
            type="email"
          />

          <Input
            id="telefone"
            name="telefone"
            label="Telefone"
            value={form.telefone}
            onChange={handleChange}
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            id="cnpj"
            name="cnpj"
            label="CNPJ"
            value={form.cnpj}
            onChange={handleChange}
          />

          <Input
            id="razaoSocial"
            name="razaoSocial"
            label="Razão Social"
            value={form.razaoSocial}
            onChange={handleChange}
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            id="nomeFantasia"
            name="nomeFantasia"
            label="Nome Fantasia"
            value={form.nomeFantasia}
            onChange={handleChange}
          />

          <Select
            id="regime"
            name="regime"
            label="Regime *"
            value={form.regime}
            onChange={handleChange}
            options={regimes}
            required
            hint="Obrigatório para gerar Proposta."
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Select
            id="tipoEntrada"
            name="tipoEntrada"
            label="Tipo de Entrada"
            value={form.tipoEntrada}
            onChange={handleChange}
            options={tiposEntrada}
          />

          <Input
            id="honorarioAbertura"
            name="honorarioAbertura"
            label="Valor (R$) Honorário de abertura"
            value={form.honorarioAbertura}
            onChange={handleChange}
            hint="Honorário de abertura"
            type="number"
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            id="honorarioMensal"
            name="honorarioMensal"
            label="Valor (R$) Honorário mensal *"
            value={form.honorarioMensal}
            onChange={handleChange}
            required
            hint="Honorário mensal (Obrigatório para gerar Proposta.)"
            type="number"
          />

          <Select
            id="segmento"
            name="segmento"
            label="Segmento *"
            value={form.segmento}
            onChange={handleChange}
            options={segmentos}
            required
            hint="Obrigatório para gerar Proposta."
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            id="qtdFuncionarios"
            name="qtdFuncionarios"
            label="A empresa possui quantos funcionários? *"
            value={form.qtdFuncionarios}
            onChange={handleChange}
            required
            hint="Obrigatório para gerar Proposta."
            type="number"
          />

          <Select
            id="possuiMovimento"
            name="possuiMovimento"
            label="Empresa tem movimento? *"
            value={form.possuiMovimento}
            onChange={handleChange}
            options={possuiMovimento}
            required
            hint="Obrigatório para gerar Proposta."
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Select
            id="ramoAtuacao"
            name="ramoAtuacao"
            label="Ramo de atuação"
            value={form.ramoAtuacao}
            onChange={handleChange}
            options={ramosAtuacao}
          />

          <Input
            id="responsavelVenda"
            name="responsavelVenda"
            label="Responsável pela venda"
            value={form.responsavelVenda}
            onChange={handleChange}
            hint="Selecione o responsável"
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Select
            id="canalVendas"
            name="canalVendas"
            label="Canal de vendas"
            value={form.canalVendas}
            onChange={handleChange}
            options={canaisVenda}
          />

          <Input
            id="indicadoPor"
            name="indicadoPor"
            label="Indicado por"
            value={form.indicadoPor}
            onChange={handleChange}
            hint="Clique aqui para adicionar"
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Select
            id="unidade"
            name="unidade"
            label="Unidade"
            value={form.unidade}
            onChange={handleChange}
            options={unidades}
          />

          <Input
            id="competenciaInicial"
            name="competenciaInicial"
            label="Competência Inicial"
            value={form.competenciaInicial}
            onChange={handleChange}
            type="date"
            hint="Preencher primeiro mês das obrigações iniciando no dia 01. Exemplo competência de Janeiro: preencher 01/01/2025."
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            id="dataContrato"
            name="dataContrato"
            label="Data de hoje para Contrato"
            value={form.dataContrato}
            onChange={handleChange}
            type="date"
          />

          <Input
            id="dataVencimento"
            name="dataVencimento"
            label="Data do primeiro vencimento"
            value={form.dataVencimento}
            onChange={handleChange}
            type="date"
            hint="Preencher dia 05, 10, 15 ou 20. Exemplo: Se a competência inicial é 01/01/2025, a data do primeiro vencimento será por exemplo 10/02/2025."
          />
        </div>

        <div className="relative w-full mb-5">
          <textarea
            id="observacoes"
            name="observacoes"
            value={form.observacoes}
            onChange={handleChange}
            placeholder=" "
            className="peer block w-full appearance-none border border-gray-300 rounded-tl-2xl rounded-tr-2xl rounded-br-2xl p-3 min-h-[100px] focus:outline-none focus:ring-1 focus:ring-purple-500/25 focus:border-purple-700 transition-all"
          />
          <label
            htmlFor="observacoes"
            className="absolute left-4 bg-white px-1 transition-all pointer-events-none text-sm text-gray-500 peer-focus:text-purple-700 peer-placeholder-shown:top-3 peer-focus:top-[-0.5rem] peer-focus:translate-y-0"
            style={{ top: form.observacoes ? '-0.5rem' : '3' }}
          >
            Observações sobre o lead
          </label>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            id="endereco"
            name="endereco"
            label="Endereço"
            value={form.endereco}
            onChange={handleChange}
            hint="Digite somente o número do endereço (Preenche Automático)"
            disabled
          />

          <Input
            id="numero"
            name="numero"
            label="Nº"
            value={form.numero}
            onChange={handleChange}
            hint="(Preenche Automático)"
            disabled
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            id="bairro"
            name="bairro"
            label="Bairro"
            value={form.bairro}
            onChange={handleChange}
            hint="(Preenche automático)"
            disabled
          />

          <Input
            id="complemento"
            name="complemento"
            label="Complemento"
            value={form.complemento}
            onChange={handleChange}
            hint="(Preenche automático)"
            disabled
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            id="cidade"
            name="cidade"
            label="Cidade"
            value={form.cidade}
            onChange={handleChange}
            hint="(Preenche automático)"
            disabled
          />

          <Input
            id="estado"
            name="estado"
            label="Estado"
            value={form.estado}
            onChange={handleChange}
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            id="uf"
            name="uf"
            label="UF"
            value={form.uf}
            onChange={handleChange}
            hint="(Preenche automático)"
            disabled
          />

          <Input
            id="cep"
            name="cep"
            label="CEP"
            value={form.cep}
            onChange={handleChange}
            hint="(Preenche Automático)"
            disabled
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            id="atividadeEconomica"
            name="atividadeEconomica"
            label="Atividade econômica"
            value={form.atividadeEconomica}
            onChange={handleChange}
            hint="(Preenche Automático)"
            disabled
          />

          <Input
            id="capitalSocial"
            name="capitalSocial"
            label="Capital Social"
            value={form.capitalSocial}
            onChange={handleChange}
            hint="(Preenche Automático)"
            disabled
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            id="situacaoCadastral"
            name="situacaoCadastral"
            label="Situação Cadastral"
            value={form.situacaoCadastral}
            onChange={handleChange}
            hint="(Preenche Automático)"
            disabled
          />

          <Input
            id="inscricaoEstadual"
            name="inscricaoEstadual"
            label="Inscrição Estadual"
            value={form.inscricaoEstadual}
            onChange={handleChange}
            hint="(Preenche automático na fase Ganho)"
            disabled
          />
        </div>
      </div>
    </BaseForm>
  );
};

export default FormNovaSequencia;